<div class="participant">Video Participant 1</div>
<div class="participant">Video Participant 2</div>
<div class="participant">Video Participant 3</div>
<div class="participant">Video Participant 4</div>
